<template>
    <div class="not-found text-center">
        <font-awesome-icon v-if="icon" :icon="icon" size="lg" />
        <p v-if="text">
            {{ text }}
        </p>
    </div>
</template>
<script setup>
import { defineProps, toRefs } from 'vue';

const props = defineProps({
    text: String,
    icon: String
});

let { text, icon } = toRefs(props);

</script>
<style>
.not-found {
    color: red;
}
</style>